import {useSessionStore, useAppStore} from '@/stores'
import {useTranslation} from 'i18next-vue'
import {useEventListener} from '@vueuse/core'

export const useDocumentEventCallback = () => {
  const app = useAppStore()
  const {t} = useTranslation()
  const session = useSessionStore()

  useEventListener(window, 'beforeunload', (event: BeforeUnloadEvent) => {
    if (app.isCall && !session.sessionFailed) {
      event.preventDefault()
      event.returnValue = t('meeting.app.unloadConfirm')
    }
  })
}
